import { Socket, connect as io } from "socket.io-client";
import { Middleware } from "redux";
import {
  chatAgentCallBack,
  connectedChatAgent,
  incomingChatAgent,
  setChatAgentScrollPosition,
} from "./chatAgentSlice";
import { IIncomingRoom } from "./types";

const chatMiddleware: Middleware = (store) => {
  let socket: Socket;
  return (next) => (action) => {
    const { user } = store.getState().auth;
    const url = String(process.env.REACT_APP_CHAT_AGENT_SOCKET);
    const domain = new URL(url);
    const pathname = "/wss/chat-agent/";
    const cleandomain = `${domain.protocol}//${domain.hostname}:${domain.port}`;
    const userName = user?.username;
    const fullName = user?.fullname;
    const deviceId = user?.deviceId;
    const tenantId = user?.tenantId;
    const type = action?.type?.split("/")[1];

    switch (type) {
      case "chatAgentWSConnecting":
        if (domain && user?.deviceId) {
          socket = io(cleandomain, {
            path: pathname,
            transports: ["websocket", "polling", "flashsocket"],
          });
          socket.on("chat-callback", (data: any) => {
            store.dispatch(chatAgentCallBack(data));
          });
          socket.on("incoming-chat-room", (data: IIncomingRoom[]) => {
            const room = data[0];
            store.dispatch(
              chatAgentCallBack({
                status: "INCOMINGROOM",
                sessionId: room.sessionId,
                roomId: room.roomId,
              })
            );
          });
          socket.on("incoming-message", (data: any) => {
            store.dispatch(setChatAgentScrollPosition("bottom"));
            store.dispatch(incomingChatAgent({ messages: data, userName }));
          });
          socket.on("connect", () => {
            console.log("connected chat agent");
            store.dispatch(connectedChatAgent(true));
            socket.emit("connect-chat", {
              deviceId,
              userName,
              tenantId,
              fullName,
            });
          });
          socket.on("disconnect", () => {
            console.log("disconnected chat agent");
            store.dispatch(connectedChatAgent(false));
          });
        }
        break;
      case "sendAgentMessage":
        socket?.emit("chat", action.payload);
        break;
      case "resolveAgentRoom":
        socket?.emit("resolve-chat", { sessionId: action.payload.sessionId });
        break;
      case "readAgentMessage":
        socket?.emit("read-chat", {
          sessionId: action.payload.sessionId,
          messageId: action.payload.messageId,
          userName,
        });
        break;
      case "typingAgentMessage":
        socket?.emit("typing-chat", {
          sessionId: action.payload.sessionId,
          userName: action.payload.userName,
        });
        break;
      case "chatAgentWSDisconnecting":
        socket?.disconnect();
        break;
      case "startAgentChat":
        socket?.emit("start-chat", {
          toUserName: action.payload.toUserName,
          tenantId: action.payload.tenantId,
        });
        break;
      case "startBroadcastAgentChat":
        socket?.emit("broadcast-chat", action.payload);
        break;
    }

    next(action);
  };
};

export default chatMiddleware;
